import { FAQS } from "../../lib/data";
import { Reveal, Overline } from "./Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="py-24 md:py-36">
    <div className="max-w-3xl mx-auto px-6 md:px-12">
      <Reveal className="text-center">
        <Overline>Good to know</Overline>
        <h2 className="mt-5 font-heading text-4xl md:text-5xl font-light tracking-tight text-charcoal">
          Frequently asked questions
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-charcoal/10"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-heading text-xl md:text-2xl text-charcoal hover:no-underline py-6"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-stone text-base font-light leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
